import { useContext } from 'react';
import { FeatureFlagContext } from './FeatureFlagContext';
/**
 * Retrieve flag data from split.io
 * @param flagName
 * @param flagAttributes
 */
export var useFeatureFlag = function (flagName, flagAttributes) {
    var _a = useContext(FeatureFlagContext), status = _a.status, client = _a.client, flagUser = _a.flagUser;
    var treatment = '';
    if (client && status.isReady) {
        treatment = client.getTreatment(flagName, flagAttributes !== null && flagAttributes !== void 0 ? flagAttributes : flagUser);
    }
    return { treatment: treatment, isLoading: !status.isReady };
};
//# sourceMappingURL=useFeatureFlag.js.map